import { useEffect, useState } from "react";
import axios from "axios";
import s from './Top.module.scss';
import { useNavigate } from "react-router-dom";

const Top = () => {
  const navigate = useNavigate();
  const [recommendedTours, setRecommendedTours] = useState([]);
  const [otherTours, setOtherTours] = useState([]);
  const [hiddenTours, setHiddenTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchTours = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/admin/tours`);
        const { recommendedTours, otherTours, hiddenTours } = response.data;
        console.log('recommendedTours', recommendedTours)
        console.log('otherTours', otherTours)
        console.log(process.env);

        setRecommendedTours(recommendedTours);
        setOtherTours(otherTours);
        setHiddenTours(hiddenTours);
      } catch (error) {
        console.error("Error fetching tours:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTours();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleCreateTour = () => {
    navigate("/tour/create");
  };

  const handleEditTour = (id) => {
    navigate(`/edit-tour/${id}`);
  };

  const handleDeleteTour = async (id) => {
    try {
      const confirmDelete = window.confirm("ツアーを削除しますか？");
      if (confirmDelete) {
        await axios.delete(`${apiUrl}/api/admin/tours/${id}`);
        setRecommendedTours(recommendedTours.filter(tour => tour.id !== id));
        setOtherTours(otherTours.filter(tour => tour.id !== id));
      }
    } catch (error) {
      console.error("Error deleting the tour:", error);
      alert("Failed to delete the tour.");
    }
  };

  const handleEditPlan = (id) => {
    navigate(`/plans/${id}`);
  };

  const handleEditImages = (id) => {
    navigate(`/edit-images/${id}`);
  };

  const TourTable = ({ title, tours, handleEditTour, handleEditImages }) => (
    <section>
      <h2>{title}</h2>
      <div className="tour-list">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>タイトル</th>
              <th>標準価格</th>
              <th>セール価格</th>
              <th>ツアーコード</th>
              <th>rezdy_id</th>
              <th>セール中</th>
              <th>順番</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {tours.map((tour) => (
              <tr key={tour.id}>
                <td>{tour.id}</td>
                <td
                  className={s.title}
                  title={tour.title}
                >
                  {tour.title}
                </td>
                <td>{tour.regular_price}</td>
                <td>{tour.sale_price}</td>
                <td>{tour.tour_code}</td>
                <td>
                  <a
                    href={`${process.env.REACT_APP_BASE_URL}/tours/${tour.rezdy_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {tour.rezdy_id}
                  </a>
                </td>
                <td>
                  {tour.is_sale ? (
                    <span>&#10003;</span>
                  ) : (
                    ""
                  )}
                </td>
                <td>{tour.popularity || ""}</td>
                <td className={s.buttons}>
                  <button
                    onClick={() => handleEditTour(tour.id)}
                    className={s.editButton}
                  >
                    ツアー編集
                  </button>
                  {tour.plans.length > 0 &&
                    <button
                    onClick={() => handleEditPlan(tour.tour_detail.id)}
                    className={s.editButton}
                    >
                    プラン編集
                    </button>
                  }
                  <button
                    onClick={() => handleEditImages(tour.id)}
                    className={s.editButton}
                  >
                    画像編集
                  </button>
                  <button
                    onClick={() => handleDeleteTour(tour.id)}
                    className={s.deleteButton}
                  >
                    削除
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );


  return (
    <div className={s.root}>
      <div className={s.buttonRoot}>
        <button onClick={handleCreateTour} className={s.createButton}>
          ツアー作成
        </button>
      </div>
      <TourTable
        title="おすすめツアーTOP5"
        tours={recommendedTours}
        handleEditTour={handleEditTour}
        handleEditImages={handleEditImages}
      />
      <TourTable
        title="その他ツアー"
        tours={otherTours}
        handleEditTour={handleEditTour}
        handleEditImages={handleEditImages}
      />
      <TourTable
        title="非公開ツアー"
        tours={hiddenTours}
        handleEditTour={handleEditTour}
        handleEditImages={handleEditImages}
      />
    </div>
  );
};

export default Top;
